const LoadMore = require('./components/loadmore/');
const Time = require('./components/time/');

module.exports = {
    LoadMore,
    Time,
}


// WEBPACK FOOTER //
// ./lib/index.js